import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-table";

const keys = addTranslations(RESOURCE_NAME, {
    name: {
        en: "Name",
        fr: "Nom",
    },
    noQuestionnaire: {
        en: "No questionnaire",
        fr: "Aucun questionnaire",
    },
    lastQuestionnaire: {
        en: "Last questionnaire",
        fr: "Dernier questionnaire",
    },
    lastQuestionnaire_active: {
        en: "Last questionnaire ({{count}})",
        fr: "Dernier questionnaire ({{count}})",
    },
    noQuestionnaireOnly: {
        en: "No questionnaire only",
        fr: "Aucun questionnaire uniquement",
    },
    lastQuestionnaireProgress: {
        en: "Progress",
        fr: "Complétion",
    },
    lastQuestionnaireProgressTooltip: {
        en: "Last questionnaire progress",
        fr: "Complétion du dernier questionnaire",
    },
    progress_min: {
        en: "Min",
        fr: "Min",
    },
    progress_max: {
        en: "Max",
        fr: "Max",
    },
    lastQuestionnaireStatus: {
        en: "Last questionnaire status",
        fr: "Statut du dernier questionnaire",
    },
    lastUpdated: {
        en: "Last updated",
        fr: "Dernière mise à jour",
    },
    answered_questions: {
        en: "Questions in progress:",
        fr: "Questions en cours:",
    },
    validated_questions: {
        en: "Completed questions:",
        fr: "Questions complétées:",
    },
    status: {
        en: "Status",
        fr: "Statut",
    },
    status_OPEN: {
        en: "Open",
        fr: "Ouvert",
    },
    status_CLOSED: {
        en: "Closed",
        fr: "Fermé",
    },
    send_email: {
        en: "Notify by email",
        fr: "Notification par email",
    },
    send_email_success: {
        en: "Emails sent successfully",
        fr: "Emails envoyés avec succès",
    },
    send_email_error: {
        en: "Failed to send emails",
        fr: "Erreur lors de l'envoi des emails",
    },
    open_preview: {
        en: "Open preview",
        fr: "Ouvrir le prévisualisation",
    },
    copy_link: {
        en: "Copy link to questionnaire",
        fr: "Copier le lien vers le questionnaire",
    },
    copy_link_success: {
        en: "Link copied to clipboard",
        fr: "Lien copié dans le presse-papiers",
    },
    copy_link_error: {
        en: "Failed to copy link to clipboard",
        fr: "Erreur lors de la copie du lien dans le presse-papiers",
    },
    action_bar_selected_suppliers: {
        en: "Selected suppliers",
        fr: "Fournisseurs sélectionnés",
    },
    action_bar_selected_suppliers_one: {
        en: "One supplier selected",
        fr: "Un fournisseur sélectionné",
    },
    action_bar_selected_suppliers_other: {
        en: "{{count}} suppliers selected",
        fr: "{{count}} fournisseurs sélectionnés",
    },
    action_bar_select_action: {
        en: "Select an action",
        fr: "Sélectionner une action",
    },
    action_bar_send_questionnaire: {
        en: "Assign a questionnaire",
        fr: "Attribuer un questionnaire",
    },
    action_bar_send_reminder: {
        en: "Notify by email",
        fr: "Notification par email",
    },
    action_bar_close_questionnaire: {
        en: "Close questionnaire",
        fr: "Fermer le questionnaire",
    },
    action_bar_reopen_questionnaire: {
        en: "Reopen questionnaire",
        fr: "Réouvrir le questionnaire",
    },
    action_bar_send_reminder_one: {
        en: "Send email to one supplier",
        fr: "Envoyer un email à un fournisseur",
    },
    action_bar_send_reminder_other: {
        en: "Send email to {{count}} suppliers",
        fr: "Envoyer un email à {{count}} fournisseurs",
    },
    action_bar_send: {
        en: "Send",
        fr: "Envoyer",
    },
    action_bar_close: {
        en: "Close",
        fr: "Fermer",
    },
    action_bar_reopen: {
        en: "Reopen",
        fr: "Réouvrir",
    },
    action_bar_close_questionnaire_one: {
        en: "Close open questionnaire of one supplier",
        fr: "Fermer le questionnaire ouvert du fournisseur",
    },
    action_bar_reopen_questionnaire_one: {
        en: "Reopen last questionnaire of one supplier",
        fr: "Réouvrir le dernier questionnaire du fournisseur",
    },
    action_bar_close_questionnaire_other: {
        en: "Close open questionnaire of {{count}} suppliers",
        fr: "Fermer le questionnaire ouvert de {{count}} fournisseurs",
    },
    action_bar_reopen_questionnaire_other: {
        en: "Reopen last questionnaire of {{count}} suppliers",
        fr: "Réouvrir le dernier questionnaire de {{count}} fournisseurs",
    },
    action_bar_close_questionnaire_success: {
        en: "Questionnaires closed successfully",
        fr: "Questionnaires fermés avec succès",
    },
    action_bar_reopen_questionnaire_success: {
        en: "Questionnaires reopened successfully",
        fr: "Questionnaires réouverts avec succès",
    },
    action_bar_close_questionnaire_error: {
        en: "Failed to close questionnaires",
        fr: "Erreur lors de la fermeture des questionnaires",
    },
    action_bar_reopen_questionnaire_error: {
        en: "Failed to reopen questionnaires",
        fr: "Erreur lors de la réouverture des questionnaires",
    },
    action_bar_open_questionnaire_error: {
        en: "Failed to open questionnaires",
        fr: "Erreur lors de l'ouverture des questionnaires",
    },
    action_bar_send_questionnaire_disabled: {
        en: "",
        fr: "",
    },
    action_bar_send_questionnaire_disabled_one: {
        en: "One supplier has an open questionnaire. Close it before opening a new questionnaire.",
        fr: "Un fournisseur a un questionnaire ouvert. Fermez-le avant d'ouvrir un nouveau questionnaire.",
    },
    action_bar_send_questionnaire_disabled_other: {
        en: "{{count}} suppliers have an open questionnaire. Close them before opening a new questionnaire.",
        fr: "{{count}} fournisseurs ont un questionnaire ouvert. Fermez-les avant d'ouvrir un nouveau questionnaire.",
    },
    action_bar_send_email_disabled: {
        en: "One supplier does not have an open questionnaire. Open a new one before sending an email.",
        fr: "Un fournisseur n'a pas de questionnaire ouvert. Ouvrez-le ou ouvrez un nouveau questionnaire avant d'envoyer un email.",
    },
    action_bar_send_email_disabled_other: {
        en: "{{count}} suppliers do not have an open questionnaire. Open a new one before sending an email.",
        fr: "{{count}} fournisseurs n'ont pas de questionnaire ouvert. Ouvrez-en un nouveau avant d'envoyer un email.",
    },
    reset: {
        en: "Reset",
        fr: "Réinitialiser",
    },
    action_bar_delete_supplier: {
        en: "Delete supplier",
        fr: "Supprimer fournisseur",
    },
    action_bar_delete_supplier_disabled: {
        en: "One supplier has data. It is not possible to delete it.",
        fr: "Un fournisseur a des données. Il n'est pas possible de le supprimer.",
    },
    action_bar_delete_supplier_disabled_other: {
        en: "{{count}} suppliers have data. It is not possible to delete them.",
        fr: "{{count}} fournisseurs ont des données. Il n'est pas possible de les supprimer.",
    },
    action_bar_delete_supplier_success: {
        en: "Suppliers deleted successfully",
        fr: "Fournisseurs supprimés avec succès",
    },
    action_bar_delete_supplier_error: {
        en: "Failed to delete suppliers",
        fr: "Erreur lors de la suppression des fournisseurs",
    },
});

export function useSupplierTableTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
